<template>
	<div class="w-100">
		<p class="mb-0 body-1-2">{{$t('hotel.promo.promo-code')}}</p>
		<p class="mb-2 body-2-2-1">{{$t('hotel.concierge.fitur.cart.apply-promo-code')}}</p>
		<div class="w-100">
			<template v-if="promo == null">
				<div class="w-100 border-semi-grey radius-12 py-2 pr-2 mb-1" :class="{'border-danger':promo_error != '' || promo_error_typing != ''}">
	    		<div class="row no-gutters">
	    			<div class="col-9 align-self-center">
	    				<div class="w-100 position-relative">
		    				<input type="text" class="border-none body-2-4 mb-0 no-focus-border pl-5 pr-3 pb-1" :placeholder="$t('hotel.concierge.fitur.cart.placeholder-promo-code')" v-model="promo_code" @blur="promoCodeToUpperCase" @keyup.enter="validatePromoCode" />
		    				<img src="../../../assets/img/icon/discount-dark.png" height="18" class="position-absolute" style="left:16px;top:4px;">
		    				<i v-if="promo_code != ''" @click="clearForm()" class="simple-icon-close text-18 text-semi-dark position-absolute cursor-pointer" style="right:8px;top:4px;"></i>
		    			</div>
	    			</div>
	    			<div class="col-3 align-self-center">
	    				<button 
	    					class="ga-btn-primary-md"
	    					@click="validatePromoCode" 
	    					:disabled="promo_loader || promo_code == '' || promo_error_typing != ''">
	              <pulse-loader :loading="promo_loader" size="12px" color="#fff" v-if="promo_loader"></pulse-loader>
			          <template v-else>
			            {{$t('hotel.concierge.promotion.apply')}}
			          </template>
	            </button>
	    			</div>
	    		</div>
	    	</div>
	    	<p class="mb-3 body-3-3-1 text-danger" v-if="promo_error != ''"><i class="simple-icon-close mr-1"></i>{{promo_error}}</p>
	      <p class="mb-3 body-3-3-1 text-danger" v-if="promo_error_typing != ''"><i class="simple-icon-close mr-1"></i>{{promo_error_typing}}</p>
	    </template>
	    <template v-else>
	    	<div class="radius-12 px-5 py-3 position-relative bg-border-green-light mb-2">
    			<p class="mb-0 body-2-1">{{promo.name}}</p>
          <p class="mb-0 body-3-3-1">{{promo.description}}</p>
    			<img src="../../../assets/img/icon/discount-dark.png" height="18" class="position-absolute" style="left:16px;top:16px;">
    			<i @click="clearPromoAffected()" class="simple-icon-close text-22 text-semi-light position-absolute cursor-pointer" style="right:16px;top:24px;"></i>
    		</div>
    		<p class="mb-3 body-3-3-1 text-danger" v-if="!is_match_product"><i class="simple-icon-close mr-1"></i> {{$t('hotel.concierge.promotion.product-not-affected')}} "{{promo.name}}".</p>
	    </template>
		</div>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	import {post,get} from '@/services/index.js';
	export default{
		data(){
			return{
				promo_code: '',
        promo_error: '',
        promo_error_typing: '',
        promo_loader: false,
        promo:null,
        is_match_product: true
			}
		},
		computed:{
			...mapGetters(['getMerchant','getVoucherOrder']),
			product_cart(){
				let data_return = {
					pos: this.getVoucherOrder.cart.length,
					product: 0,
					variant: 0
				}
				for(let pos of this.getVoucherOrder.cart){
					data_return.product += pos.product.length
					for(let product of pos.product){
						data_return.variant += product.variant_list.length
					}
				}

				return `pos_${data_return.pos}_product_${data_return.product}_variant_${data_return.variant}`
			}
		},
		watch:{
			promo_code(){
        this.promo_error_typing = ''
        if(this.promo_code.includes(' ')){
          this.promo_error_typing = this.$t('hotel.concierge.promotion.cannot-contain-space')
        } else if(this.promo_code != '' && /^[A-Za-z0-9]+$/.test(this.promo_code) == false){
          this.promo_error_typing = this.$t('hotel.concierge.promotion.only-letters-number')
        } else{
          this.promo_error_typing = ''
        }
      },
			product_cart(){
				if(this.promo != null){
					this.is_match_product = this.checkIfProductInPromotion()
				}
			},
			is_match_product(){
      	if(this.is_match_product){
      		this.applyPromoToProduct()
      	}
      },
		},
		mounted(){
    	if(this.getVoucherOrder.promo_code != ''){
    		this.promo_code = this.getVoucherOrder.promo_code
    		this.validatePromoCode()
    	}
    },
    methods:{
    	...mapMutations(['setSpecificVoucherOrder','resetSpecificVoucherOrder','setVoucherOrderPromoCode']),
    	clearForm(){
    		this.promo_code = ''
        this.promo_error = ''
        this.promo_loader = false
        this.promo = null
    	},
    	promoCodeToUpperCase(){
        let copy = this.promo_code.toUpperCase()
        this.promo_code = copy
      },
      clearPromoAffected(){
      	this.applyPromoToProduct(false).then(res=>{
      		this.setVoucherOrderPromoCode("")
	        this.clearForm()
      	}).catch(err=>{
      		console.log(err)
      		this.promo_error = err
      	})
      },
      validatePromoCode(){
        if(!this.promo_loader && this.promo_code != '' && this.promo_error_typing == ''){
          this.promo_loader = true
          this.promo_error = ''
          get("CORE_HOTEL",`merchant-pos/promotion/${this.promo_code}`,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.promo = res.data
              this.is_match_product = this.checkIfProductInPromotion()
              if(this.is_match_product){
              	this.setVoucherOrderPromoCode(res.data.promo_code)
              	this.applyPromoToProduct()
              }
            }else{
              this.promo_error = this.$t('hotel.concierge.promotion.not-found')
            }
            this.promo_loader = false
          })
        }
      },
      checkIfProductInPromotion(){
      	let is_promo = false
    		for(let pos of this.getVoucherOrder.cart){
    			for(let product of pos.product){
    				for(let product_promo of this.promo.product_affected_list){
      				if(product.is_variant){
      					for(let cart_variant of product.variant_list){
      						if(cart_variant.data.product_ga_pos_id == product_promo.product_ga_pos_id){
      							is_promo = true
	      						break
      						}
      					}
      					if(is_promo){
		      				break
		      			}
      				}else{
	      				if(product.data.product_ga_pos_id == product_promo.product_ga_pos_id){
	      					is_promo = true
	      					break
	      				}
      				}
      			}
      			if(is_promo){
      				break
      			}
    			}
    		}
      	return is_promo
      },
      applyPromoToProduct(is_apply=true){
      	return new Promise((success,fail)=>{
      		for(let i_pos = 0 ; i_pos < this.getVoucherOrder.cart.length; i_pos++){
		      	for(let i_product=0; i_product < this.getVoucherOrder.cart[i_pos].product.length; i_product++){

	      			let cart = this.getVoucherOrder.cart[i_pos].product[i_product]

	      			for(let i_promo=0; i_promo < this.promo.product_affected_list.length;i_promo++){
	      				let product_promo = this.promo.product_affected_list[i_promo]

	      				if(cart.is_variant){

	      					for(let i_variant = 0; i_variant < cart.variant_list.length; i_variant++){
	      						let cart_variant = cart.variant_list[i_variant]
	      						if(cart_variant.data.product_ga_pos_id == product_promo.product_ga_pos_id){
	      							let params = {
	      								merchant_pos_id: cart.data.merchant_pos.id,
	      								index_product: i_product,
	      								is_variant: cart.product.is_variant,
	      								index_variant: i_variant,
	      								data: product_promo
	      							}
	      							if(is_apply){
	      								this.setSpecificVoucherOrder(params)
	      							}else{
	      								this.resetSpecificVoucherOrder(params)
	      							}
	      						}
	      						if((i_pos+1) == this.getVoucherOrder.cart.length && (i_product+1) == this.getVoucherOrder.cart[i_pos].product.length && (i_promo+1) == this.promo.product_affected_list.length && (i_variant+1) == cart.variant_list.length){
	      							success()
	      						}
	      					}
	      				}else{
		      				if(cart.data.product_ga_pos_id == product_promo.product_ga_pos_id){
		      					let params = {
		      						merchant_pos_id: cart.data.merchant_pos.id,
	    								index_product: i_product,
	    								is_variant: cart.is_variant,
	    								index_variant: 0,
	    								data: product_promo
	    							}
	    							if(is_apply){
	    								this.setSpecificVoucherOrder(params)
	    							}else{
	    								this.resetSpecificVoucherOrder(params)
	    							}
		      				}
		      				if((i_pos+1) == this.getVoucherOrder.cart.length && (i_product+1) == this.getVoucherOrder.cart[i_pos].product.length && (i_promo+1) == this.promo.product_affected_list.length){
	    							success()
	    						}
	      				}
	      			}
	      		}
	      	}
      	})
      }
    }
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/upselling/VoucherPromoCode.vue